import React, { Key, useEffect, useMemo, useState } from "react";
import { Input, Table, Select, Button } from "antd";
import usePagination from "../../../../../../../utils/v2/usePagination";
import { ColumnProps } from "antd/lib/table/interface";
import useRequest from "../../../../../../../utils/useRequest";
import Form from "rc-field-form";
import {
    newfindPolyvReplayList,
    lookPlayback,
    PolyvItem,
    QueryPolyvReplaySearch
} from "../../../../../../../service/CourseDetail/resource";
import useSelection from "../../../../../../../utils/v2/useSelection";
import { overFlow } from "../../../../../../../components/overFlow";
import Style from "./index.module.scss";
import { useAtomValue } from "jotai";
import { termListAtom } from "service/stores/CommonStore";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";

interface Props {
    onCheck: (checks: PolyvItem[]) => void;
}

const Index = ({ onCheck }: Props) => {
    const pagination = usePagination(20);
    const rowSelection = useSelection();
    const batchList = useAtomValue(termListAtom);

    const [form] = Form.useForm<QueryPolyvReplaySearch>();

    const [query, setQuery] = useState<QueryPolyvReplaySearch>({});

    const [data, { loading: tableLoading }] = useRequest(
        () =>
            newfindPolyvReplayList({
                ...query,
                ...pagination.params
            }),
        {},
        [query, pagination.params]
    );

    const videoMap = useMemo(() => {
        return new Map<Key, PolyvItem>();
    }, []);

    useEffect(() => {
        data?.data?.forEach(item => {
            if (!videoMap.has(item.vid)) {
                videoMap.set(item.vid, item);
            }
        });
    }, [data?.data]);

    useEffect(() => {
        const SELECT: PolyvItem[] = [];
        rowSelection.selected.forEach(item => {
            const v = videoMap.get(item);
            if (v) {
                SELECT.push(v);
            }
        });
        onCheck(SELECT);
    }, [rowSelection.selected]);

    const columns: ColumnProps<PolyvItem>[] = [
        {
            title: "学期",
            dataIndex: "batchName",
            render: (text: string) => overFlow(text)
        },
        {
            title: "课程信息",
            dataIndex: "courseName",
            render: (text: string) => overFlow(text)
        },
        {
            title: "回放分类",
            dataIndex: "type",
            width: 100,
            render: text => {
                return <span>{text === "1" ? "三分屏" : "屏幕回放"}</span>;
            }
        },
        {
            title: "视频名称",
            dataIndex: "title",
            render: (text: string) => overFlow(text)
        },
        {
            title: "开始时间",
            dataIndex: "startTime",
            width: 180,
            render: (text: string) => overFlow(text)
        },

        {
            title: "预览",
            dataIndex: "vid",
            width: 120,
            render: (text, record) => (
                <Button type="link" onClick={() => openurl(text, record)}>
                    预览
                </Button>
            )
        }
    ];

    async function openurl(text: string, record: PolyvItem) {
        try {
            const result = await lookPlayback({
                channelId: record?.channelId,
                vid: text
            });
            window.open(result?.watchUrl);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }
    const { Option } = Select;

    return (
        <div>
            <div className={Style.searchRow}>
                <Form form={form} onFinish={setQuery} className={Style.root}>
                    <span className={Style.trem}> 学期：</span>
                    <Form.Field name="batchNo">
                        <Select
                            mode="multiple"
                            className={Style.select}
                            placeholder="请选择学期">
                            {batchList?.map(item => (
                                <Option key={item.batchNo}>
                                    {item.batchName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Field>
                    <span className={Style.trem}>分类：</span>
                    <Form.Field name="type">
                        <Select
                            mode="multiple"
                            className={Style.select}
                            placeholder="请选择视频分类">
                            <Option key="1">三分屏</Option>
                            <Option key="2">屏幕回放</Option>
                        </Select>
                    </Form.Field>
                    <span className={Style.kcxx}> 课程信息：</span>
                    <Form.Field name="courseName">
                        <Input
                            placeholder="输入课程名称关键词查询"
                            className={Style.search}
                        />
                    </Form.Field>
                    <Button type="primary" icon="search" onClick={form.submit}>
                        查询
                    </Button>
                    &nbsp;
                    <Button icon="redo" onClick={() => form.resetFields()}>
                        重置
                    </Button>
                </Form>
            </div>

            <Table
                loading={tableLoading}
                rowKey="vid"
                rowSelection={{
                    selectedRowKeys: rowSelection.selected as number[],
                    onChange: rowSelection.setSelected
                }}
                className={Style.table}
                {...pagination.tableProps(data?.totalSize)}
                dataSource={data?.data}
                columns={columns}
                scroll={{ y: "40vh" }}
            />
        </div>
    );
};

export default Index;
